/**
 * CoralPlacerPage — "Tools → Coral Placer": renders the native Reef Coral
 * Placer (catalog interactive guide + digital aquascape placement). This
 * replaced the old compiled iframe app so every view is source-controlled,
 * matches the ReefApp design system, and saves the operator's placements,
 * uploaded aquascape photos, and coral edits to the Pi.
 */
import { CoralPlacerApp } from '../coral-placer/CoralPlacerApp';

export function CoralPlacerPage() {
  return (
    <div className="h-[calc(100vh-7rem)] w-full md:h-[calc(100vh-5rem)]">
      <CoralPlacerApp />
    </div>
  );
}
